import { render, staticRenderFns } from "./ResendMessageModal.vue?vue&type=template&id=e2107fca&scoped=true&"
import script from "./ResendMessageModal.vue?vue&type=script&lang=js&"
export * from "./ResendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./ResendMessageModal.vue?vue&type=style&index=0&id=e2107fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2107fca",
  null
  
)

export default component.exports